import { render, staticRenderFns } from "./MyCommunityInfo.vue?vue&type=template&id=469afdd2&scoped=true&"
import script from "./MyCommunityInfo.vue?vue&type=script&lang=js&"
export * from "./MyCommunityInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyCommunityInfo.vue?vue&type=style&index=0&id=469afdd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469afdd2",
  null
  
)

export default component.exports